<template>
  <div class="profile">
    <div class="container">
      <div class="intro h-100">
        <div class="row h-100 align-items-center">
          <div class="col-md-6 ml-3">
            <h3>Profile settings</h3>

            <p>Change your profile settings here</p>
          </div>
          <div class="col-md-5">
            <img src="/img/svg/profile.svg" width="300" alt class="img-fluid" />
          </div>
        </div>
      </div>

      <div class="profile-content">
        <ul class="nav nav-pills ml-3" id="myTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >Profile</a>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active pt-3"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div class="container">
              <div class="row">
                <div class="col-md-6" v-if="user">
                  <div class="form-group">
                    <input
                      type="text"
                      name
                      v-model="user.name"
                      placeholder="Full name"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="col-md-6" v-if="user">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="user.phone"
                      placeholder="Phone"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="col-md-12" v-if="user">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="user.address"
                      placeholder="Address"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="col-md-8" v-if="user">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="user.postCode"
                      placeholder="Postcode"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <input
                      type="submit"
                      @click="updateProfile"
                      value="Save Changes"
                      class="btn btn-primary w-100"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                </div>
                 <div class="col-md-4">
                </div>
                 <div class="col-md-4">
                  <div class="form-group">
                    <input
                      type="button"
                      @click="resetPassword"
                      value="Reset password email"
                      class="btn btn-success w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb, db, auth } from "../firebase";
import { mapGetters } from 'vuex'
import { dbSchema} from "../store"

export default {
  name: "Profile",
  components: {},
  props: {
    msg: String
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  },

  methods: {
    resetPassword() {
      auth
        .sendPasswordResetEmail(auth.currentUser.email)
        .then(() => {
          Toast.fire({
            type: "success",
            title: "Email sent"
          });
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateProfile() {
      var {isLoggedIn, isAdmin, ...userObject} = this.user
      db.collection(dbSchema.users).doc(this.user.id).set(userObject, {merge: true});
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
